import React, { FunctionComponent, useState, useEffect } from 'react';
import { Auth } from 'aws-amplify';
import { Redirect, withRouter } from 'react-router-dom';
import { Mutation } from 'react-apollo';
import queryString from 'query-string';
import { ApolloError } from 'apollo-boost';

import Loading from 'components/Loading';
import { getGraphQLError, defaultErrorMessage } from 'helpers/getGraphQLError';
import { WithRouterProps } from 'helpers/types';
import ErrorBoundary from 'components/ErrorBoundary';
import { CSVParams } from 'scenes/CSVExport/CSVExport.helper';
import { getUserIdentityId } from 'scenes/Report/Report.helper';

import EXPORT_CARD_TRANSACTION_EVENTS from './CSVCreator.mutations';

type QueryResponse = {
  exportCardTransactions: { uuid: string };
};

type ResponseParams = {
  data?: QueryResponse;
  loading?: boolean;
  error?: ApolloError;
};

const renderRedirect = ({ exportCardTransactions }: QueryResponse) => (
  <Redirect to={`/csv-export/status/${exportCardTransactions.uuid}`} />
);

const CSVCreator: FunctionComponent<WithRouterProps> = ({ location }) => {
  const [userIdentityId, setIdentityId] = useState<string | null>(null);
  const params = queryString.parse(location.search) as CSVParams;
  useEffect(() => {
    (async () => {
      const credentials = await Auth.currentUserCredentials();
      setIdentityId(getUserIdentityId(credentials));
    })();
  }, []);

  if (!userIdentityId) return null;

  return (
    <ErrorBoundary>
      <Mutation mutation={EXPORT_CARD_TRANSACTION_EVENTS}>
        {(
          exportCardTransactions: Function,
          { data, loading, error }: ResponseParams,
        ) => {
          if (loading) {
            return <Loading loading />;
          }

          if (error) {
            getGraphQLError(defaultErrorMessage, true, error);
          }

          if (data) {
            return renderRedirect(data);
          }

          exportCardTransactions({ variables: { params, userIdentityId } });

          return null;
        }}
      </Mutation>
    </ErrorBoundary>
  );
};

export default withRouter(CSVCreator);
